import * as Joi from 'joi';
export const commonV1DeprecatedProps = {
    dataLabels: Joi.boolean(),
    detailedLabels: Joi.boolean(),
    stackedLabels: Joi.boolean(),
    visibleSeriesNames: Joi.array().items(Joi.string().allow('')),
    axisExtremes: Joi.object({
        x: Joi.array().items(Joi.object({
            min: Joi.number(),
            max: Joi.number(),
        })),
        y: Joi.array().items(Joi.object({
            min: Joi.number(),
            max: Joi.number(),
        })),
    }),
    gridLineConfig: Joi.object({
        xGridlineEnabled: Joi.boolean(),
        yGridlineEnabled: Joi.boolean(),
        x: Joi.boolean(),
        y: Joi.boolean(),
    }),
    isZoomed: Joi.boolean(),
    mapViewport: Joi.object({
        center: Joi.array()
            .length(2)
            .items(Joi.number()),
        zoomLevel: Joi.number(),
    }),
    responsiveLayoutDisabled: Joi.boolean(),
    showLinearRegressionLine: Joi.boolean(),
    markersEnabled: Joi.boolean(),
    roundedNumbers: Joi.boolean(),
    yAxisShared: Joi.boolean(),
    'yAxis.isStackedAsPercent': Joi.boolean(),
    pivotState: Joi.object({
        rowExpandedPaths: Joi.array().items(Joi.array().items(Joi.string())),
        columnExpandedPaths: Joi.array().items(Joi.array().items(Joi.string())),
        useTreeLayout: Joi.boolean(),
        showPivotSummaries: Joi.boolean(),
    }),
    hidePivotSummaries: Joi.boolean(),
    summaryMode: Joi.string(),
    useFlatLayout: Joi.boolean(),
    isHeatmapOverlayed: Joi.boolean(),
    yAxisRange: Joi.object({
        min: Joi.number(),
        max: Joi.number(),
    }),
    dataOffset: Joi.number(),
    yAxis: Joi.any(),
};
export const ClientStateV1Schema = Joi.object({
    ...commonV1DeprecatedProps,
    custom_color_selector_array: Joi.array().items(Joi.string()),
    systemSeriesColors: Joi.object().pattern(Joi.string().allow(''), Joi.string()),
    seriesColors: Joi.object().pattern(Joi.string().allow(''), Joi.string()),
    systemMultiColorSeriesColors: Joi.object().pattern(Joi.string(), Joi.object().pattern(Joi.string().allow(''), Joi.array().items(Joi.string().allow(null)))),
    multiColorSeriesColors: Joi.object().pattern(Joi.string(), Joi.object().pattern(Joi.string().allow(''), Joi.array().items(Joi.string().allow(null)))),
    axisProperties: Joi.object().pattern(Joi.string(), Joi.object()),
    columnProperties: Joi.object().pattern(Joi.string(), Joi.object()),
    chartProperties: Joi.object().pattern(Joi.string(), Joi.any()),
});
//# sourceMappingURL=v1.js.map